import { ModalContentToggler, ModalStates, useModalContentToggler } from '@components'

import { ModalProps } from '@billy/design-system'
import { useCallback, useSyncExternalStore } from 'react'

import { EditManualBankAccountFormBody } from '@features/bankAccounts/elements/EditManualBankAccountModal/elements/EditManualBankAccountFormBody'
import { EditManualBankAccountFormFooter } from '@features/bankAccounts/elements/EditManualBankAccountModal/elements/EditManualBankAccountFormFooter'
import { useCsvAccountCreationForm } from '@features/bankAccounts/elements/EditManualBankAccountModal/hooks/useCsvAccountCreationForm'

import { connectBankModalUiSourceStore } from '../../utils/connectBankModalUiSourceStore'
import { ConnectBankContent } from '../ConnectBankContent'
import { BankView } from '../ConnectBankContent/enums/bankView'
import { ConnectBankModalStateId } from './enums/connectBankModalStateId'

type ConnectBankModalProps = ModalProps

const ConnectBankBody = () => {
  const { setActiveState } = useModalContentToggler()
  const uiSource = useSyncExternalStore(connectBankModalUiSourceStore.subscribe, connectBankModalUiSourceStore.get)

  const handleImportCsvClick = useCallback(() => {
    setActiveState(ConnectBankModalStateId.ImportCsv)
  }, [setActiveState])

  return (
    <ConnectBankContent bankView={BankView.ConnectModal} onImportCsvClick={handleImportCsvClick} uiSource={uiSource} />
  )
}

export const ConnectBankModal = ({ ...modalProps }: ConnectBankModalProps) => {
  const form = useCsvAccountCreationForm(modalProps.id)

  const states: ModalStates<ConnectBankModalStateId> = [
    {
      id: ConnectBankModalStateId.ConnectBank,
      headerTKey: 'bankreconciliation.connect_bank.title',
      modalBody: <ConnectBankBody />,
    },
    {
      id: ConnectBankModalStateId.ImportCsv,
      headerTKey: 'bank.account.modal.header.create',
      modalBody: <EditManualBankAccountFormBody form={form} />,
      modalFooter: <EditManualBankAccountFormFooter form={form} />,
      backwardsNavigationStateId: ConnectBankModalStateId.ConnectBank,
      withBackwardsNavigation: true,
    },
  ]

  return (
    <ModalContentToggler<ConnectBankModalStateId>
      autofocusOnInput
      initialState={ConnectBankModalStateId.ConnectBank}
      size="s"
      states={states}
      {...modalProps}
    />
  )
}
